module.exports = __webpack_public_path__ + "img/sld3.dfe12caf.jpg";